import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, Button, Card, Typography, getTestId, useBreakpoint, WHITE, fitContentWidth, isValidObject } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
import { getOfferPopupWidgetStyles } from './OfferPopupWidgetStyles';
import { StatusCardTimerText } from '../status-card-widget/components/status-card-timer-text';
export var OfferPopupWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OfferPopupWidget' : _props$testID,
    title = props.title,
    subTitle = props.subTitle,
    imageUrl = props.imageUrl,
    offerHeading = props.offerHeading,
    offerSubHeading = props.offerSubHeading,
    ctaText = props.ctaText,
    onCtaPressMetaData = props.onCtaPressMetaData,
    onUserAction = props.onUserAction,
    style = props.style,
    _props$isVisible = props.isVisible,
    isVisible = _props$isVisible === void 0 ? true : _props$isVisible,
    offerTitle = props.offerTitle,
    accessibilityProps = props.accessibilityProps,
    _props$timerProps = props.timerProps,
    timerProps = _props$timerProps === void 0 ? {} : _props$timerProps;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true,
      allowMdAsLargeScreen: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var offerPopupWidgetStyles = getOfferPopupWidgetStyles(isSmallScreen);
  if (!title && !subTitle && !imageUrl && !offerHeading && !offerSubHeading && !ctaText) {
    return null;
  }
  return _jsx(_Fragment, {
    children: isVisible && _jsxs(View, Object.assign({
      style: fitContentWidth()
    }, accessibilityProps, {
      children: [!!offerTitle && _jsx(Typography, {
        text: offerTitle,
        color: WHITE,
        type: (isSmallScreen ? 'h6' : 'h5') + "-bold",
        style: offerPopupWidgetStyles.offerTitle
      }), _jsxs(Card, Object.assign({}, getTestId(testID), {
        style: [offerPopupWidgetStyles.container, style]
      }, {
        children: [!!title && _jsx(Typography, {
          text: title,
          type: "body-para-" + (isSmallScreen ? 'md' : 'xl') + "-bold",
          style: offerPopupWidgetStyles.textAlignCenter
        }), !!subTitle && _jsx(Typography, {
          text: subTitle,
          color: BLACK_700,
          type: "body-para-" + (isSmallScreen ? 'xs' : 'md'),
          style: [offerPopupWidgetStyles.subTitle, offerPopupWidgetStyles.textAlignCenter]
        }), !!imageUrl && _jsx(Image, {
          resizeMode: "contain",
          source: {
            uri: imageUrl,
            width: isSmallScreen ? 160 : 202,
            height: isSmallScreen ? 148 : 156
          },
          style: offerPopupWidgetStyles.imageUrl
        }), !!offerHeading && _jsx(Typography, {
          text: offerHeading,
          type: "body-para-" + (isSmallScreen ? 'sm' : 'lg') + "-bold",
          style: [offerPopupWidgetStyles.offerHeading, offerPopupWidgetStyles.textAlignCenter]
        }), isValidObject(timerProps) && _jsx(StatusCardTimerText, Object.assign({}, timerProps, {
          onUserAction: onUserAction
        }, getTestId(testID, 'timer'))), !!offerSubHeading && _jsx(Typography, {
          text: offerSubHeading,
          color: BLACK_700,
          type: "body-para-" + (isSmallScreen ? 'xs' : 'md'),
          style: [offerPopupWidgetStyles.offerSubHeading, offerPopupWidgetStyles.textAlignCenter]
        }), !!ctaText && _jsx(Button, {
          title: ctaText,
          size: isSmallScreen ? 'md' : 'lg',
          version: "variable-width",
          style: offerPopupWidgetStyles.ctaText,
          onPress: () => {
            onCtaPressMetaData && onUserAction(Object.assign({
              id
            }, onCtaPressMetaData), props);
          }
        })]
      }))]
    }))
  });
};
OfferPopupWidgetComponent.genericRendererKey = 'AirOfferPopupWidget';